import { ReactElement, ReactNode } from 'react';

import { PaletteColor } from '../ThemeProvider';

export const ModalWidth = {
	Normal: 'Normal',
	Extra: 'Extra',
	Ultra: 'Ultra',
	Super: 'Super',
	Full: 'Full',
} as const;
export type ModalWidth = (typeof ModalWidth)[keyof typeof ModalWidth];

export type ModalProps = {
	id?: string;
	closeModal: () => void;
	children: ReactNode;
	canClose?: boolean;
	isOpen?: boolean;
	onBack?: () => void;
	showBackButton?: boolean;
	width?: ModalWidth;
	noPadding?: boolean;
	borderColor?: PaletteColor;
	backgroundColor?: PaletteColor;
	footer?: ReactElement;
	additionalOverlay?: ReactElement;
	hasOverflowY?: boolean;
	showTooltip?: boolean;
} & /* You must pass at least one of title/aria-label/aria-labelledby.
 * Passing a titleElement means you can't pass tElemente
 */ (
	| {
			title: string;
			titleElement?: never;
			'aria-label'?: string;
			'aria-labelledby'?: string;
	  }
	| {
			title?: string;
			titleElement?: never;
			'aria-label': string;
			'aria-labelledby'?: string;
	  }
	| {
			title?: string;
			titleElement?: never;
			'aria-label'?: string;
			'aria-labelledby': string;
	  }
	| {
			title?: never;
			titleElement: ReactElement;
			'aria-label': string;
			'aria-labelledby'?: string;
	  }
	| {
			title?: never;
			titleElement: ReactElement;
			'aria-label'?: string;
			'aria-labelledby': string;
	  }
);
